import classNames from 'clsx';
import React, { type FC, type ReactElement } from 'react';

import styles from './SubscriptionInfoBlock.css';

interface IProps {
    title: string;
    id: string;
    size?: 'medium' | 'large';
}

export const SubscriptionInfoBlock: FC<IProps> = ({ title, id, children, size = 'medium' }): ReactElement => {
    return (
        <div
            className={classNames(styles.root, {
                [styles[`root_${id}`]]: id,
                [styles[`root_size_${size}`]]: size,
            })}
        >
            <div className={styles.title}>{title}</div>
            <div className={styles.info}>{children}</div>
        </div>
    );
};

SubscriptionInfoBlock.displayName = 'SubscriptionInfoBlock';
